/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { Grid, Typography2, breakpoints, useTheme } from '@coursera/cds-core';

import { getTranslatedProductName } from 'bundles/browse-common/legacy/utils/getTranslatedProductName';

const getStyles = (theme: Theme) => ({
  productTypePill: css`
    border-radius: 2px;
    font-size: 14px !important;
    font-weight: normal;
    width: fit-content;
    text-decoration: none;
    color: ${theme.palette.black};
    display: inline-block;
    text-align: center;
    background-color: var(--cds-color-grey-50);
  `,

  withoutGradient: css`
    padding: 2px 11px 3px;
    font-weight: 'normal';
  `,

  pillContainer: css`
    justify-content: center ${breakpoints.down('xs')} {
      justify-content: flex-start;
    }
  `,
});

type Props = {
  productTypeName?: string;
};

const ProductTypePill: React.FC<Props> = ({ productTypeName }) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const productNameTranslated = getTranslatedProductName(productTypeName);

  return (
    <Grid container css={styles.pillContainer}>
      <Typography2 component="span" css={[styles.productTypePill, styles.withoutGradient]}>
        {productNameTranslated}
      </Typography2>
    </Grid>
  );
};

export default ProductTypePill;
